import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	padding: 0 40px;
`;

const StyledItemsContainer = styled.div`
	display: flex;
	gap: 20px;
`;

const StyledShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 130px;
	bottom: 1px;
	left: 0;
	z-index: 3;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
	transition:
		opacity 0.3s ease,
		height 0.3s ease;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 15px;
	left: 19px;
	z-index: 4;
	display: flex;
	flex-direction: column;

	& > ${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledPriceContainer = styled.div`
	position: relative;
	display: flex;
	gap: 10px;
	justify-content: flex-start;
	align-items: center;
	margin: 12px 0 0;
	transition: margin 0.3s ease;
`;

const StyledPrice = styled.div<{ $isDonate?: boolean }>`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 20px;
		color: ${(props) => (props.$isDonate ? '#FFBB00' : '#ffffff')};
		padding-top: 1px;
		transition: color 0.3s ease;
	}
`;

const StyledOldPrice = styled.div`
	position: relative;
	display: flex;
	gap: 6px;
	padding: 0 5px;
	margin-top: 2px;

	img {
		width: 12px;
		height: 12px;
		margin-top: 2px;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
		filter: grayscale(100%);
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
		transition: color 0.3s ease;
	}

	.line {
		position: absolute;
		top: 7px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ff3737;
	}
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledMoreBlock = styled.div`
	align-self: flex-start;
	width: fit-content;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-top: 0;
	height: 0;
	overflow: hidden;
	transition:
		height 0.3s ease,
		margin-top 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	&:hover ${Text}, &:hover img {
		opacity: 1;
	}
`;

const StyledTagsContainer = styled.div`
	position: absolute;
	top: 19px;
	left: 19px;
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	justify-content: flex-start;
`;

const StyledItemImage = styled.img`
	position: absolute;
	top: 60px;
	left: 50%;
	height: 172px;
	transform: translateX(-50%);
	user-select: none;
	pointer-events: none;
	transition:
		height 0.3s ease,
		top 0.3s ease;
`;

const StyledItemContainer = styled.div`
	position: relative;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	padding: 19px 19px 16px 19px;
	width: 352px;
	height: 339px;
	overflow: hidden;
	transition:
		background-color 0.3s ease,
		border 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
		border: 1px solid rgba(255, 255, 255, 1);

		${StyledShadow} {
			opacity: 1;
			height: 200px;
		}

		${StyledMoreBlock} {
			height: 12px;
			margin-top: 16px;
		}

		${StyledItemImage} {
			height: 191px;
			top: 40px;
		}
	}
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledDiscountTimerContainer,
	StyledItemContainer,
	StyledItemImage,
	StyledItemsContainer,
	StyledMoreBlock,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
	StyledTagsContainer,
};
